import { defineStore } from 'pinia';
import type { AdminMenuType  } from "~/types/layout/admingnb";

export const useAdminGnbStore = defineStore('admingnb', {
    state : () : AdminMenuType => ({
        depth : [
            {
                id : 1,
                label : '수집 게시판관리',
                children : [
                    {id : 111, label : '울산테크노파크', url : '/sys-admin/crawl/utp/list'},
                    {id : 112, label : '울산정보산업진흥원', url : '/sys-admin/crawl/uipa/list'},
                    {id : 113, label : '울산경제일자리진흥원', url : '/sys-admin/crawl/ubpi/list'},
                    // {id : 114, label : '울산상공회의소', url : '/sys-admin/crawl/koc/list'},
                    {id : 115, label : '울산창조경제혁신센터', url : '/sys-admin/crawl/ccei/list'},
                    // {id : 116, label : '울산연구원', url : '/sys-admin/crawl/uri/list'},
                    {id : 117, label : 'NTIS', url : '/sys-admin/crawl/crawlntis/list'},
                ]
            },
            {
                id : 2,
                label : '저장 게시판관리',
                children : [
                    {id : 201, label: '울산테크노파크', url : '/sys-admin/save/utpsave/list'},
                    {id : 202, label: '울산정보산업진흥원', url : '/sys-admin/save/uipasave/list'},
                    {id : 203, label: '울산경제일자리진흥원', url : '/sys-admin/save/ubpisave/list'},
                    // {id : 204, label: '울산상공회의소', url : '/sys-admin/save/kocsave/list'},
                    {id : 205, label: '울산창조경제혁신센터', url : '/sys-admin/save/cceisave/list'},
                    // {id : 206, label: '울산연구원', url : '/sys-admin/save/urisave/list'},
                    {id : 207, label: 'NTIS', url : '/sys-admin/save/ntissave/list'},
                ]
            },
            {
                id : 3,
                // pending: true, // 준비중
                label : '사업통계관리',
                children : [
                    // {id : 301, label: '통계 데이터 편집', url : '/sys-admin/stats/stats'},
                    {id : 302, label: '통계 데이터 편집', url : '/sys-admin/stats/StatsExcelEditor'},
                ]
            },
            {
              id: 4,
              label : '공지사항/발간물 관리',
              children : [
                  {id : 401, label : '공지사항 게시판 관리', url : '/sys-admin/notice/adminnotice/list'},
                  {id : 402, label : '발간물 게시판 관리', url : '/sys-admin/archive/adminarchive/list'},
              ]
            },
            {
                id : 5,
                pending: true, // 준비중
                label : '통계관리',
                children : [
                    { id: 501, label: '방문자 통계', url: '/sys-admin/visit/stats' },
                ]
            }
        ]
    })
})